/** prime仓库存储的商品数据 */

import { CartItem } from '@/types/cart';
import { ExtraServiceType } from '@/types/extraService';

/** 商城需要展示prime标签的商品套餐id */
export const PrimeTagCommodityMap: string[] = [];

// 商城套餐id=>prime仓库的sku料号匹配Map
export const PrimeCommodityMap = {
  '2108': '2108',
  '2994': '2994',
  '2995': '2995',
  '3001': '3001',
  '2997': '2997',
  '3006': '3006',
  '3008': '3008',
  '3002': '3002',
  '3012': '3012',
  '3013': '3013',
  '3005': '3005',
  '2976': '2976',
  '2977': '2977',
  '2983': '2983',
  '2971': '2971',
  '2972': '2972',
  '2981': '2981',
  '2982': '2982',
  '2978': '2978',
  '2973': '2973',
  '2974': '2974',
  '2975': '2975',
  '2993': '2993',
  '2992': '2992',
  '2141': '2141',
  '2895': '2895',
  '2629': '2629',
  '2601': '2601',
  '2990': '2990',
  '3375': '3375',
  '2118': '2118',
  '3611': '3611',
  '3619': '3619',
  '2641': '2641',
  '3885': '3885',
  '2994+2990': '2994+2990',
  '2995+2990': '2995+2990',
  '3006+2990': '3006+2990',
  '3002+2990': '3002+2990',
  '3012+2990': '3012+2990',
  '3008+2990': '3008+2990',
  '2997+2990': '2997+2990',
  '3375+2990': '3375+2990',
  '3013+2990': '3013+2990',
  '3005+2990': '3005+2990',
  '2118+2119': '2118+2119',
  '2108+2119': '2108+2119',
};

export const PrimeKv = {
  pc: 'https://res.insta360.com/static/76b874e088771c3970128eaf6da978c2/primePC.jpg',
  mob: 'https://res.insta360.com/static/50c6a5bfbd830a50611f66ceeae0eb82/primeMob.jpg',
};

/** 传入购物车item，返回prime仓库的sku料号 暂时只做了care的套餐绑定处理 */
export const getItemPrimeSkuId = (item: RecursivePartial<CartItem>) => {
  const { bind_services } = item;
  const care = bind_services?.find((service) => service.serviceType === ExtraServiceType.CARE);
  const care_plus = bind_services?.find((service) => service.serviceType === ExtraServiceType.CARE_PLUS);

  const itemId = item.commodityId + `${care ? '+' + care.id : ''}` + `${care_plus ? '+' + care_plus.id : ''}`;
  const primeSkuId = PrimeCommodityMap[itemId as keyof typeof PrimeCommodityMap];
  if (primeSkuId) {
    return primeSkuId;
  }

  return undefined;
};
